<template>
  <v-app>
    <NavBar
      v-if="
        $route.path == '/Main' ||
        $route.path == '/MainMenu' ||
        $route.path == '/ManagePreRegister' ||
        $route.path == '/ManageUser' ||
        $route.path == '/ManageRole' ||
        $route.path == '/MyQR' ||
        $route.path == '/CallLift' ||
        $route.path == '/ParkingInformation' ||
        $route.path == '/PreRegister' ||
        $route.path == '/Redemption' ||
        $route.path == '/TerminalStamp' ||
        $route.path == '/ManageQuotaRate'
      "
    />
    <!-- <v-main v-if="$route.path != '/MainMenu'">
      <div>
        <router-view></router-view>
      </div>
    </v-main> -->
    <!-- <v-main
      id="grad2"
      v-if="$route.path == '/MainMenu'"
      style="display: grid; align-content: center"
    >
      <div>
        <router-view></router-view>
      </div>
    </v-main> -->
    <v-content>
      <div>
        <router-view></router-view>
      </div>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  
  mounted() {
    this.checkInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token }).catch(() => {});
      }
    }, 60 * 1000);
  },

  beforeDestroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
};
</script>

<style>
@font-face {
  font-family: "English";
  src: local("English"), url(./assets/Font/Kanit-Regular.ttf);
}
/* .v-main__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
} */

.v-content__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 959px) {
  /* .v-main__wrap {
    background-color: white;
    width: 80%;
  } */
  .v-content__wrap {
    background-color: white;
    width: 80%;
  }
}
* {
  font-family: "English";
}

#app {
  color: #444444;
}
/* 
#grad1 {
    height: 200px;
    background: #78A3D4; 
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF); 
    background: -moz-linear-gradient(#78A3D4, #FFF); 
    background: linear-gradient(#78A3D4, #FFF); 
} */
/* #grad2 { */
/* height: auto; */

/* background: #78A3D4;
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF); 
    background: -moz-linear-gradient(#78A3D4, #FFF);  */
/* background: linear-gradient( rgba(255, 253, 253, 0.8), rgba(255, 253, 253, 0.2) ), url(./assets/mainmenu_bg.jpg); */
/* background-repeat: no-repeat;   */
/* background-position: center; */
/* background-size: cover; */
/* background-image: url(./assets/mainmenu_bg.jpg); */
/* object-fit: cover; */
/* } */

::-webkit-scrollbar {
  display: none;
}
</style>
